import React from "react";

export default function Annexure4(props) {
  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-3xl font-bold mb-6 text-yellow-500">
          Safeguarding D/deaf children
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-yellow-500">Annexure-4</h2>
      </div>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Children experience multiple barriers to disclosing abuse and this
            is further exacerbated for D/deaf children and young people. Many
            fear that they will not be believed or are concerned about the
            consequences that may follow from communicating abuse. If a child
            feels able to communicate their experiences to you, it is essential
            that this is handled sensitively and professionally.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Research suggests disabled children including D/deaf children may be
            more vulnerable to abuse for several reasons:
          </span>
          <ul className="space-y-2 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Poor practice resulting from not understanding the child’s
                support needs
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Attitudes and assumptions about disability
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Lack of awareness and a belief disabled children are not abused
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">Targeting by abusers</span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Not being able to put into words or signs what has happened to
                them
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Not having friends and a peer group to talk to
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Not being able to read and/or use the internet to get questions
                answered and compare experiences
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Not seeing themselves reflected in dramas, stories, film or TV
                programs, so not identifying with stories written to help
                children and young people to explore right and wrong
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Having injuries, marks and behaviors explained away by illness
                or disability
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Being frightened to tell of an experience if they have to rely
                on the abuser for support and help
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Bearing in mind that D/deaf children and young people can be and are
            disadvantaged by the above and other experiences, it is important
            for everyone to be extra vigilant in creating a safe culture.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            If a D/deaf child has decided to approach you disclosing personal
            information, or you have a D/deaf child referred to you who has
            disclosed information, that has raised concerns, there are important
            points to bear in mind that relate specifically to working with a
            D/deaf child, as highlighted in bold below.
          </span>
          <ul className="space-y-4 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                It is important to remember that any action should be child
                centered. Never put a child under pressure to tell.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure the immediate safety of the child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure you follow your own agency’s child protection policies
                and procedures whether the child is D/deaf or hearing.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                When talking to a D/deaf child, if it becomes apparent that they
                are starting to disclose personal information that raises
                concerns, it is important to think about a{" "}
                <b>suitable ‘safe’ location</b> in which to talk to the D/deaf
                child, ensuring that the location is{" "}
                <b>
                  private, (particularly as signed language is visible to all –
                  across rooms, through windows, etc., unlike spoken language!)
                </b>{" "}
                somewhere the child is familiar with and feels comfortable. It
                needs to be a safe environment with{" "}
                <b>
                  appropriate lighting for you and the child to be able to see
                  each other’s signing clearly
                </b>{" "}
                with no interruptions, to encourage the D/deaf child to
                communicate freely.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The D/deaf child may require a <b>loop system</b> if available –
                the speaker’s voice is picked up by a special microphone which
                sends the voice directly to the D/deaf child’s hearing aids,
                reducing the interference of background noise.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                If any child begins to disclose information but asks that no-one
                else be told about it, they should be made aware that any
                information may need to be passed to the appropriate
                person/organisation under their duty of care, if someone is
                considered to be at risk of perceived or actual harm from
                another person.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Establish the{" "}
                <b>D/deaf child’s preferred communication method</b> so that
                appropriate communication support or a qualified sign language
                interpreter is utilised to meet their needs. If the person
                communicating with the D/deaf child <b>“can sign”</b>, they
                still need ask themselves whether they are the right person to
                be involved - can they sign fluently enough to fully understand
                the child fully so that the information obtained is accurate,
                without the D/deaf child having to repeat/rephrase/simplify what
                they are saying for the interviewer to understand?
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Do not be tempted to use a family member or friend to
                ‘translate’ simply because they ‘can sign’ - perpetrators have
                been known to specifically befriend D/deaf children knowing they
                have few people who understand them, thus putting the
                ‘befriender’ in a position of power over the D/deaf child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure regular breaks, as the{" "}
                <b>D/deaf child’s visual attention span</b> may be very short.
                Where they need to constantly watch an interpreter, they can
                become exhausted very quickly. Unlike a hearing child who can
                look away, stare out of the window and still be listening, for
                the D/deaf child to look away from the interpreter means they
                have lost communication, until they look back to the
                interpreter.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                It is possible that information provided by the D/deaf child is
                not clear or is lacking detail, or that they are repeating
                information told to them by another child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>
                  A D/deaf child may want to protect an adult who has been
                  hurting them
                </b>
                , and although this could also be the case for a hearing child,
                it could be more so for a D/deaf child if someone has made an
                effort to develop a relationship/communicate with them when
                others around have not, due to their deafness.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>The Deaf world is very small</b> and it may be that if the
                alleged perpetrator is known to the child they are likely to be
                known by their family, involved in the Deaf community and/or
                local Deaf school, etc., making it particularly difficult for
                the child to disclose information.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Do not reassure the child that everything will be better/all
                right if they disclose – as one cannot guarantee this.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Do tell the child what you are going to do next.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Following safeguarding policies, it will be necessary to alert
                other people/organisations.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1 font-bold">
            During the discussion of a possible safeguarding concern with the
            D/deaf child:
          </span>
          <ul className="space-y-4 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                For a prearranged interview with a D/deaf child it is essential
                to{" "}
                <b>book, and brief, the sign language interpreter beforehand</b>
                , so they have an understanding of the situation, and also allow
                the interpreter a few minutes to ‘chat’ to the D/deaf child to
                establish good, clear communication.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>
                  The interpreter will be aware of their own role/boundaries
                </b>{" "}
                – refer to the World Association of Sign Language Interpreters
                (WASLI)’s International Code of Conduct (available on{" "}
                <a
                  href="http://www.wasli.org/"
                  className="text-yellow-500 underline"
                >
                  www.wasli.org
                </a>
                )
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Remind the child that{" "}
                <b>
                  the interpreter is not allowed to tell others in the Deaf
                  community
                </b>{" "}
                what they hear in the meeting. The Deaf world is very small and
                many Deaf people are concerned that what they tell someone will
                be passed on to others therefore confidentiality is always an
                issue.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Sometimes the D/deaf child may find it difficult to express what
                they are feeling or what happened, so it is worth considering
                alternative methods, for example using toys, drawing, etc. to
                elicit as much information as possible.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Always use language that is a simple/straightforward as possible
                to ensure that the D/deaf child fully understands what is being
                asked of them.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Do not ask questions except to clarify what they have told you,
                but instead allow the D/deaf child to lead at their own pace. It
                is{" "}
                <b>
                  important to use facial expressions that are open, warm and
                  encouraging
                </b>{" "}
                rather than those implying frustration, disapproval, or focusing
                on something other than the D/deaf child. Also do not allow them
                to see that you are shocked or upset by what they are saying,
                for example, as they may feel that you are unable to deal with
                the situation and can leave the D/deaf child feeling
                embarrassed.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Show the D/deaf child that you are taking what they say
                seriously and that you are interested, give encouraging nods,
                sit forward, give eye contact, so they know they have your
                attention.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>
                  Don’t look at the interpreter, but look at the D/deaf child
                </b>{" "}
                – refer to the Deaf Awareness and Communication tips which is
                available.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that you record what the D/deaf child has said/where the
                disclosure occurred/the date and time/who was present, etc. It
                is worth noting details that can be identified through the
                D/deaf child’s non-verbal communication – were they emotional,
                angry, aggressive or withdrawn?
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                When a D/deaf child discloses information, it is worth
                reflecting it back to them to check that you have understood
                correctly.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                When you have obtained as much information as is
                necessary/appropriate, again reassure the D/deaf child that they
                have done the right thing in telling you and repeat that it will
                be followed up with the designated safeguarding team and the
                relevant authorities who will talk more, and who will be
                concerned about the D/deaf child’s safety.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            The person recording this information must contact the designated
            Safeguarding team/appropriate organisation as soon as possible, as
            any delay may put the D/deaf child at further risk.
          </span>
          <span className="text-gray-700 block mb-1">
            Anyone coming into contact with children and families has a duty to
            safeguard and promote the welfare of children – any concerns should
            be referred appropriately. A professional may be approached by
            children's services and asked to provide information about a child
            or family or to be involved in an assessment. This may happen
            regardless of who made the initial referral. A request for help or a
            specific service to the child or a member of their family may be
            received as part of an agreed plan and could contribute to the
            reviewing of the child's progress.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Points to bear in mind:
          </h2>
          <ul className="space-y-4 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">1.</span>
              <span className="text-gray-700">
                Clear communication for D/deaf children is vital. Don’t assume
                that you need to exaggerate body language/expressions when
                working with a D/deaf child, as this could have the effect of
                making it difficult for them to develop a rapport, discourage
                eye contact, and may sway the child into not disclosing and/or
                may create confusion around what is being communicated.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">2.</span>
              <span className="text-gray-700">
                A D/deaf child will quickly pick up on any non-verbal clues, so
                ensure that facial expressions are accurate. When thinking hard
                for example, it’s easy to present as frowning. A D/deaf child
                may not pick up associated auditory clues such ‘mmm…’ that,
                alongside the frown to a hearing person may clearly indicate
                thought, but to a D/deaf child may indicate that the person is
                unhappy, annoyed, puzzled or sceptical.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">3.</span>
              <span className="text-gray-700">
                Don’t use unqualified/inexperienced interpreters. Any
                interpreter should be qualified (have received in-depth training
                on translation skills, in addition to being fluent in both the
                spoken and signed languages being used, and will be experienced
                in identifying non-verbal clues contained within the D/deaf
                child’s communication such as unusual eye contact/body
                language/sign formation/signing structure/use of vocabulary,
                etc. Professional interpreters will have received training in
                how to deal with their own emotions in response to graphic
                discussion content, for example.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">4.</span>
              <span className="text-gray-700">
                Don’t use teachers, friends or parents to act as interpreters.
                It may seem the easy option but they are not trained in
                interpretation and may miss vital information disclosed by the
                child, which could, if it had been translated accurately, be
                used to support legal proceedings at a later date. Additionally
                the child may feel more anxious in an already uncomfortable
                situation having to relate details to a person they know and who
                may well be shocked, embarrassed, upset, themselves! (And of
                course as previously mentioned they may be the alleged
                perpetrator!)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">5.</span>
              <span className="text-gray-700">
                A D/deaf child will often not know people’s names, even the
                names of family members or friends. This is not unusual, and
                instead the child may have a ‘name sign’ (similar to hearing
                people having a nickname) by which the person is known to them.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">6.</span>
              <span className="text-gray-700">
                Don’t rely on paper and pen for communication with D/deaf
                children, as they may have delayed literacy skills, and be too
                embarrassed to say they don’t understand what’s been written or
                that they can’t express what they want to say via the written
                word. Alternative methods need to be found which are natural,
                fluent methods of communication for the D/deaf child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">7.</span>
              <span className="text-gray-700">
                Ensure the D/deaf child and their family are provided with or
                signposted to appropriate support.
              </span>
            </li>
          </ul>
        </div>

        <div className="flex flex-row items-center justify-end">
            <div className="rounded-xl p-2 bg-[#efc94c] text-white font-bold">
                Source: DeafKidz International
            </div>
        </div>
      </div>
    </div>
  );
}
